<template>
  <b-form-row class="modal-file-uploader-row">
    <b-col cols="12" lg="12" class="d-flex flex-column h-100">
      <LoadingSpinner v-if="uploadingFiles" :display-text="$gettext('Uploading files. This might take a while.')" />

      <div style="display: flex; justify-content: space-between; align-items: flex-end; gap: 1rem; margin-bottom: 1rem;">
        <div>
          {{ $gettext('Total file size:') }} <span :class="{ 'text-danger': maxSizeExceeded }">{{ niceBytes(totalFileSize, 1000, true) }}</span> / {{ niceBytes(maxTotalFileSize*1000*1000, 1000, true) }}
        </div>
        <!-- <GekkoButton
          v-if="invoiceFiles && invoiceFiles.length > 0"
          @click="uploadAndAttach"
          :text="$gettext('Upload and attach')"
          icon="fa-solid fa-upload"
        /> -->
      </div>
      
      <FileUploader
        ref="file-uploader"
        showsize
        :file-size-max="maxTotalFileSize"
        @updated-queued-files="updateInvoiceFiles"
      />

      <div v-if="maxSizeExceeded" class="text-danger" style="font-size: 14px; padding: 0.5rem; margin-top: 1rem;">
        {{ $gettextInterpolate(maxSizeExceededText, { size: niceBytes(totalFileSize, 1000, true), max: maxTotalFileSize }) }}
      </div>
    </b-col>
  </b-form-row>
</template>

<script>
import { mapGetters } from "vuex";
import { niceBytes } from "@/utils/";

import DocumentUploadService from "@/store/services/document.upload.service.js";

import FileUploader from "@/components/ui/FileUploader";

import GekkoButton from "@/components/GekkoButton"
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"

export default {
  name: 'FileUploaderFull',
  components: {
    FileUploader,
    GekkoButton,
    LoadingSpinner
  },
  props: {
    maxTotalFileSize: {
      type: Number,
      default: 10
    },
    documentName: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      invoiceFiles: null,
      uploadingFiles: false,
    }
  },
  computed: {
    ...mapGetters({ 
      currentCompany: "main/getCurrentCompany",
    }),
    maxSizeExceeded () {
      return (this.totalFileSize > (this.maxTotalFileSize*1000*1000))
    },
    maxSizeExceededText () {
      return this.$gettext('Total size of files (%{ size }) exceeds upload limit. Please make sure your uploads do not exceed %{ max } MB.')
    },
    totalFileSize () {
      let totalFileSize = 0
      if (this.invoiceFiles) {
        for (var i = 0; i < this.invoiceFiles.length; i++) {
          totalFileSize += this.invoiceFiles[i].size;
        }
      }

      // TODO Existing files size calculation for edit correction 
      // if (this.existingDocumentList) {
      //   for (var i = 0; i < this.existingDocumentList.length; i++) {
      //     this.totalFileSize += this.existingDocumentList[i].totalFileSize;
      //   }
      // }

      return totalFileSize
    },
  },
  methods: {
    /**
     * Gets Dropzone Files from fileUploader component and sets this.invoiceFiles
     */
    updateInvoiceFiles () {
      this.invoiceFiles = this.$refs['file-uploader'].getDropzoneFiles()

      // Files will be automatically uploaded and attached
      if (this.invoiceFiles && this.invoiceFiles.length > 0) {
        this.uploadAndAttach()
      }
    },
    /**
     * Alias for utils/niceBytes
     */
    niceBytes (size, base, unit = false) {
      return niceBytes(size, base, unit)
    },
    uploadAndAttach () {
      const description = this.$gettext('document uploaded for %(name)s');
      const uploadData = {
        files: this.invoiceFiles,
        company_profile: this.currentCompany.id,
        description: description.replace("%(name)s", this.documentName)
      }
      if (this.invoiceFiles && this.invoiceFiles.length > 0) {
        this.uploadingFiles = true
        DocumentUploadService.bulkUpload(uploadData).then((response) => {
          this.uploadingFiles = false

          // evaluate each upload response status
          const recently_uploaded = response
          recently_uploaded.forEach(upload => {
            let showUploadError = false
            let error_text = ''
            switch (upload.status) {
              case 201:
                // add files to attachments
                // this.documentSelected(upload.data)
                this.$emit('document-selected', upload.data)
                break;
              case 499:
                this.$store.commit('togglePremiumModal', 'web_documents_filelimit');
                break;
              case 400:
                showUploadError = true
                if (upload.data && upload.data.file) {
                  error_text = this.$gettext("No file was submitted.")
                } else if (upload.data && upload.data.non_field_errors) {
                  error_text = upload.data.non_field_errors
                } else {
                  error_text = this.$gettext("Error uploading document.")
                }
                break;
              case 413:
                showUploadError = true
                error_text = upload.data.detail
                break;
              default:
                showUploadError = true
                error_text = this.$gettext("Something went wrong...")
                break;
            }
            if (showUploadError) {
              this.$store.commit('setAlert', {
                title: this.$gettext("Error"),
                text: error_text,
                variant: "danger",
                duration: 4
              });
            }
          });

          // empty dropzone file list and invoiceFiles array
          this.$refs['file-uploader'].clear()
          this.invoiceFiles = null

          // hide file uploader
          // this.showFileUploader = false
        }).catch((error) => {
          console.log('error', error)
        })
      }
    },
  }
}
</script>

<style lang="scss">

</style>